import React from "react";
import { Typography } from "@material-ui/core";
import { get } from "lodash";

const TypographyField = ({ record, variant, source }) => (
  <Typography variant={variant}>{get(record, source)}</Typography>
);

export default TypographyField;
